var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScrollView = function SvgScrollView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1316 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#scroll-view_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#scroll-view_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 1300,
    height: 232,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#828D9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 30,
    width: 111,
    height: 16,
    rx: 4,
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 255,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#scroll-view_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.5 53.5a1.499 1.499 0 1 1 3 0 1.499 1.499 0 1 1-3 0Zm0-5.5a1.499 1.499 0 1 1 3 0 1.499 1.499 0 1 1-3 0Zm1.5-7a1.499 1.499 0 1 0 0 3 1.499 1.499 0 1 0 0-3Z",
    fill: "#435369"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 88,
    width: 1260,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 112,
    width: 1260,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 136,
    width: 1236,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 160,
    width: 853,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.45 208.908 6.953 6.531c.24.225.36.338.5.366a.52.52 0 0 0 .193 0c.142-.028.261-.141.5-.366l6.953-6.531a5.203 5.203 0 0 0 .549-6.982l-.31-.399c-1.968-2.536-5.918-2.111-7.301.787a.54.54 0 0 1-.974 0c-1.383-2.898-5.333-3.323-7.301-.787l-.31.399a5.203 5.203 0 0 0 .549 6.982Z",
    stroke: "#828D9B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.322 213 4.445-8.79v-.074h-5.14v-1.318h6.731v1.362l-4.43 8.82h-1.606Z",
    fill: "#828D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.326 201.778c.674 1.009.674 2.413.674 5.222 0 2.809 0 4.213-.674 5.222a4 4 0 0 1-1.104 1.104c-.881.589-2.064.663-4.222.673V214l-1.106 2.211a1 1 0 0 1-1.788 0L95 214v-.001c-2.158-.01-3.34-.084-4.222-.673a4.002 4.002 0 0 1-1.104-1.104C89 211.213 89 209.809 89 207c0-2.809 0-4.213.674-5.222a4.002 4.002 0 0 1 1.104-1.104C91.787 200 93.19 200 96 200h2c2.809 0 4.213 0 5.222.674a4 4 0 0 1 1.104 1.104ZM94 205h6M94 209h3",
    stroke: "#828D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.979 213v-1.114l3.446-3.569c.368-.388.671-.728.91-1.019.241-.295.422-.575.541-.841.12-.265.179-.546.179-.845 0-.338-.079-.63-.238-.875a1.563 1.563 0 0 0-.652-.572 2.081 2.081 0 0 0-.929-.203c-.365 0-.683.074-.955.223-.272.15-.48.36-.626.632-.146.272-.219.59-.219.954h-1.467c0-.619.143-1.161.428-1.625a2.903 2.903 0 0 1 1.173-1.079c.497-.259 1.063-.388 1.696-.388.639 0 1.203.128 1.69.383.49.252.873.596 1.148 1.034.275.434.413.925.413 1.471 0 .378-.071.748-.214 1.109-.139.361-.383.764-.731 1.208-.348.441-.831.976-1.451 1.606l-2.024 2.118v.075h4.584V213h-6.702Z",
    fill: "#828D9B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#scroll-view_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 260,
    width: 1300,
    height: 208,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 280,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#828D9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 282,
    width: 111,
    height: 16,
    rx: 4,
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 302,
    width: 255,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#scroll-view_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.5 305.5c0-.829.67-1.5 1.5-1.5s1.5.671 1.5 1.5a1.5 1.5 0 1 1-3 0Zm0-5.5c0-.829.67-1.5 1.5-1.5s1.5.671 1.5 1.5a1.5 1.5 0 1 1-3 0Zm1.5-7a1.5 1.5 0 1 0-.001 3.001A1.5 1.5 0 0 0 1268 293Z",
    fill: "#435369"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 340,
    width: 1260,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 364,
    width: 1260,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 388,
    width: 406,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.45 436.908 6.953 6.531c.24.225.36.338.5.366a.52.52 0 0 0 .193 0c.142-.028.261-.141.5-.366l6.953-6.531a5.203 5.203 0 0 0 .549-6.982l-.31-.399c-1.968-2.536-5.918-2.111-7.301.787a.54.54 0 0 1-.974 0c-1.383-2.898-5.333-3.323-7.301-.787l-.31.399a5.203 5.203 0 0 0 .549 6.982Z",
    stroke: "#828D9B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.322 441 4.445-8.79v-.074h-5.14v-1.318h6.731v1.362l-4.43 8.82h-1.606Z",
    fill: "#828D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.326 429.778c.674 1.009.674 2.413.674 5.222 0 2.809 0 4.213-.674 5.222a4 4 0 0 1-1.104 1.104c-.881.589-2.064.663-4.222.673V442l-1.106 2.211a1 1 0 0 1-1.788 0L95 442v-.001c-2.158-.01-3.34-.084-4.222-.673a4.002 4.002 0 0 1-1.104-1.104C89 439.213 89 437.809 89 435c0-2.809 0-4.213.674-5.222a4.002 4.002 0 0 1 1.104-1.104C91.787 428 93.19 428 96 428h2c2.809 0 4.213 0 5.222.674a4 4 0 0 1 1.104 1.104ZM94 433h6M94 437h3",
    stroke: "#828D9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.979 441v-1.114l3.446-3.569c.368-.388.671-.728.91-1.019.241-.295.422-.575.541-.841.12-.265.179-.546.179-.845 0-.338-.079-.63-.238-.875a1.563 1.563 0 0 0-.652-.572 2.081 2.081 0 0 0-.929-.203c-.365 0-.683.074-.955.223-.272.15-.48.36-.626.632-.146.272-.219.59-.219.954h-1.467c0-.619.143-1.161.428-1.625a2.903 2.903 0 0 1 1.173-1.079c.497-.259 1.063-.388 1.696-.388.639 0 1.203.128 1.69.383.49.252.873.596 1.148 1.034.275.434.413.925.413 1.471 0 .378-.071.748-.214 1.109-.139.361-.383.764-.731 1.208-.348.441-.831.976-1.451 1.606l-2.024 2.118v.075h4.584V441h-6.702Z",
    fill: "#828D9B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#scroll-view_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 488,
    width: 1300,
    height: 208,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 508,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#828D9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 510,
    width: 111,
    height: 16,
    rx: 4,
    fill: "#ABB2BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 530,
    width: 255,
    height: 16,
    rx: 4,
    fill: "#EAECEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#scroll-view_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.5 533.5c0-.829.67-1.5 1.5-1.5s1.5.671 1.5 1.5a1.5 1.5 0 1 1-3 0Zm0-5.5c0-.829.67-1.5 1.5-1.5s1.5.671 1.5 1.5a1.5 1.5 0 1 1-3 0Zm1.5-7a1.5 1.5 0 1 0-.001 3.001A1.5 1.5 0 0 0 1268 521Z",
    fill: "#435369"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "scroll-view_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1316v557H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "scroll-view_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1256 36)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "scroll-view_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1256 288)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "scroll-view_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1256 516)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scroll-view_svg__b",
    x: 4,
    y: 5,
    width: 1308,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.180392 0 0 0 0 0.25098 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1838_56054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1838_56054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scroll-view_svg__d",
    x: 4,
    y: 257,
    width: 1308,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.180392 0 0 0 0 0.25098 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1838_56054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1838_56054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scroll-view_svg__f",
    x: 4,
    y: 485,
    width: 1308,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.180392 0 0 0 0 0.25098 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1838_56054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1838_56054",
    result: "shape"
  })))));
};

export default SvgScrollView;